import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'
import { BeneficiaryType } from 'views/TerminateContract/TerminateForm/initialValues'

interface BeneficiaryIbanFieldProps {
  index: number
  required?: boolean
}

export const BeneficiaryIbanField: React.FC<BeneficiaryIbanFieldProps> = ({
  index,
  required,
}) => {
  return (
    <Field name={`beneficiaries[${index}]iban`}>
      {({ field, meta }: FieldProps<BeneficiaryType['iban']>) => (
        <FormFieldWrapper
          name={field.name}
          required={required}
          label={t('terminateContract:labels.iban')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
        >
          <TextInput {...field} />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
